import type { PropsWithChildren } from "react";
import { authClient } from "@/api/auth";

export function SignedOut({ children }: PropsWithChildren) {
	const { data, isPending } = authClient.useSession();

	if (isPending || data) {
		return null;
	}

	return <>{children}</>;
}
